import { SxProps, Theme } from '@mui/material';

export const claimColors = {
  navy: '#7ba7ff',
  navyDark: '#5b8def',
  red: '#f87171',
  redDark: '#ef4444',
  cardMuted: '#232936',
  border: '#2d3548',
  textMuted: '#9aa3b2',
};

export const claimSx = {
  mainPaper: {
    p: 4,
    borderRadius: 2,
    backgroundColor: 'background.paper',
    border: '1px solid',
    borderColor: 'divider',
  } satisfies SxProps<Theme>,

  headerBar: {
    display: 'flex',
    flexDirection: 'column',
    gap: 1,
    p: 2,
    backgroundColor: claimColors.cardMuted,
    borderRadius: 1,
    border: '1px solid',
    borderColor: 'divider',
  } satisfies SxProps<Theme>,

  sectionCard: {
    flex: '1 1 300px',
    minWidth: 0,
    p: 3,
    backgroundColor: 'background.paper',
    borderRadius: 2,
    border: '1px solid',
    borderColor: 'divider',
  } satisfies SxProps<Theme>,

  sectionTitle: {
    color: claimColors.navy,
    fontWeight: 600,
    mb: 2,
    pb: 1,
    borderBottom: `2px solid ${claimColors.red}`,
  } satisfies SxProps<Theme>,

  sectionTitleRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    pb: 1,
    mb: 3,
    borderBottom: `2px solid ${claimColors.red}`,
  } satisfies SxProps<Theme>,

  claimNumber: {
    color: claimColors.red,
    fontWeight: 'bold',
  } satisfies SxProps<Theme>,

  label: {
    fontWeight: 600,
    color: 'text.primary',
  } satisfies SxProps<Theme>,

  value: {
    color: 'text.secondary',
  } satisfies SxProps<Theme>,

  nestedRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 2,
    p: 2,
    backgroundColor: claimColors.cardMuted,
    borderRadius: 1,
    border: '1px solid',
    borderColor: 'divider',
  } satisfies SxProps<Theme>,

  inventoryRow: {
    p: 2,
    backgroundColor: claimColors.cardMuted,
    borderRadius: 1,
    border: '1px solid',
    borderColor: 'divider',
  } satisfies SxProps<Theme>,

  btnPrimary: {
    backgroundColor: 'primary.main',
    textTransform: 'none',
    px: 3,
    '&:hover': { backgroundColor: 'primary.dark' },
  } satisfies SxProps<Theme>,

  btnOutlined: {
    textTransform: 'none',
    px: 3,
    color: 'primary.main',
    borderColor: 'divider',
    '&:hover': {
      borderColor: 'primary.main',
      backgroundColor: 'rgba(91, 141, 239, 0.08)',
    },
  } satisfies SxProps<Theme>,

  btnOutlinedAccent: {
    color: claimColors.red,
    borderColor: claimColors.red,
    textTransform: 'none',
    '&:hover': {
      borderColor: claimColors.redDark,
      color: claimColors.redDark,
      backgroundColor: 'rgba(248, 113, 113, 0.1)',
    },
  } satisfies SxProps<Theme>,

  attachmentChip: {
    backgroundColor: 'rgba(91, 141, 239, 0.15)',
    color: claimColors.navy,
    fontWeight: 500,
  } satisfies SxProps<Theme>,

  thumbBox: {
    borderRadius: 1,
    border: '1px solid',
    borderColor: 'divider',
    overflow: 'hidden',
    backgroundColor: claimColors.cardMuted,
  } satisfies SxProps<Theme>,

  link: {
    color: claimColors.navy,
    fontWeight: 500,
    '&:hover': { color: claimColors.red },
  } satisfies SxProps<Theme>,

  emptyText: {
    color: 'text.secondary',
    fontStyle: 'italic',
    py: 2,
  } satisfies SxProps<Theme>,
};
